export default {
  userFlow: state => state.userFlow,
  userFlowHasImages: state => state.userFlowHasImages,
  userId: state => state.userId
}
